export default __webpack_public_path__ + "static/expression-dark-cbacbdb46aea1f45b7320be31afa7433.png";